import { render, staticRenderFns } from "./ObjectWindow.vue?vue&type=template&id=6c170eb2&"
import script from "./ObjectWindow.vue?vue&type=script&lang=js&"
export * from "./ObjectWindow.vue?vue&type=script&lang=js&"
import style0 from "./ObjectWindow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports